import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

/**
- Centralized helper to grab tracking data safely.
 */
export const getTrackingData = async () => {
  const getRawCookie = (name) => {
    if (typeof document === 'undefined') return null;
    const match = document.cookie.match(
      new RegExp('(^|;\\s*)' + name + '=([^;]*)')
    );
    return match ? match[2] : null;
  };

  let fbcValue = getRawCookie('_fbc') || "";

  if (!fbcValue && typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    const fbclid = urlParams.get('fbclid');
    
    if (fbclid) {
      fbcValue = `fb.1.${Date.now()}.${fbclid}`;
    }
  }

  // Restore IP Address fetching for anonymous event validation
  let userIp = "";
  try {
    const ipRes = await fetch('https://api.ipify.org?format=json');
    const ipData = await ipRes.json();
    userIp = ipData.ip;
  } catch (e) { 
    console.warn("Could not fetch IP"); 
  }

  return {
    fbp: getRawCookie('_fbp') || "",
    fbc: fbcValue,
    userAgent: typeof navigator !== 'undefined' ? navigator.userAgent : "",
    ip: userIp
  };
};

/**
- Fires server-side Meta Events with automatic data sanitization
 */
export const sendServerSideMetaEvent = async (
  eventName,
  customData = {},
  userEmail = null,
  userPhone = null,
  eventId = null
) => {
  const trackingData = await getTrackingData();

  let finalEmail = userEmail;
  if (!finalEmail && typeof window !== 'undefined') {
    finalEmail = window.localStorage.getItem('user_email') || null;
  }

  // --- UPDATED: AUTOMATIC PRICE & CURRENCY INJECTION ---
  const sanitizedCustomData = { ...customData };

  // 1. Always enforce currency for commerce events
  if (!sanitizedCustomData.currency) {
    sanitizedCustomData.currency = 'INR';
  }

  // 2. Sanitize value if it exists, or set a safe fallback to prevent CAPI errors
  if (sanitizedCustomData.value !== undefined && sanitizedCustomData.value !== null) {
    if (typeof sanitizedCustomData.value === 'string') {
      sanitizedCustomData.value = Number(
        sanitizedCustomData.value.replace(/[^\d.]/g, '')
      );
    }
  } else if (['AddToCart', 'InitiateCheckout', 'Purchase', 'ViewContent'].includes(eventName)) {
    sanitizedCustomData.value = 0; 
  }

  try {
    const trackEvent = httpsCallable(functions, 'trackMetaEvent');

    await trackEvent({
      eventName,
      eventUrl: window.location.href,
      trackingData,
      customData: sanitizedCustomData,
      userEmail: finalEmail,
      userPhone,
      eventId 
    });
  } catch (error) {
    console.error("Meta Event Error:", error);
  }
};

export const getTrackingDataForCheckout = async () => {
  return await getTrackingData();
};